<template>
    <div>
        <div class="mt-2">
            <span v-if="loading">
                <i class="far fa-circle-notch fa-spin"></i> Récupération des débiteurs
            </span>
            
            <div class="ix-table-box" v-if="!loading && debtors.length > 0">
                <table class="ix-table ix-table-sm" >
                    <tbody>
                        <tr v-for="(debtor, index) in debtors" v-bind:key="index">
                            <td>
                                <span v-html="truncate(debtor.company, 20)"></span>
                            </td>
                            <td class="text-right">{{ currency(debtor.amount) }}</td>
                            <td class="text-center">{{ debtor.percent }}%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            route : String,
        },
        data() {
            return {
                loading: true,
                debtors: [],
            };
        },
        methods : {
            getData : async function(){
                this.loading = true;
                fetch(this.route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.debtors = data
                    this.loading = false;
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        async mounted() {
            await this.getData();
        }
    }
</script>
